import { Navigate, Outlet } from "react-router-dom";
import { usePermissions } from "../../security";

export default function PermissionRoute({
  permission,
  children,
  redirectTo = "/unauthorized",
}) {
  const { hasPermission, loading, error } = usePermissions();

  if (loading) return null;

  if (error) {
    return <Navigate to="/permission-error" replace />;
  }

  const allowed = hasPermission(permission.endpoint, permission.method);

  if (!allowed) return <Navigate to={redirectTo} replace />;
  return children ?? <Outlet />;
}
